export const CompanyUen = {
  ADECCO: '198500164K',
  E2I: '200704772C',
  HHQ: '201721612D',
  PERSOLKELLY: '200007268E',
}

